import {
  BETSLIP_ERROR_CODE,
  BETSLIP_VIOLATION,
  constants,
  get,
  isEmptyCollection,
} from '@atlas/core';

const { BET_TYPE } = constants;

const validationMethodsMap = {
  [BET_TYPE.SINGLE]: (selectedBet, state) => {
    const { settings } = state;
    const maxOdds = get(settings, 'single.maxOdds');

    if (maxOdds == null || selectedBet.odds == null) {
      return false;
    }

    const errors = {};

    // Starting to accumulating validation errors
    if (selectedBet.odds > maxOdds) {
      errors[selectedBet.requestId] = {
        requestId: selectedBet.requestId,
        violations: [
          {
            code: BETSLIP_VIOLATION.MAX_ODDS_AMOUNT_EXCEEDED,
            violationInfo: { maxOdds },
          },
        ],
      };
    }

    // If no validation errors was found - then its ok
    if (isEmptyCollection(errors)) {
      return false;
    }

    // Returning finded errors
    return {
      code: BETSLIP_ERROR_CODE.BET_VALIDATION_FAILED,
      errors,
    };
  },
  [BET_TYPE.MULTIPLE]: (selectedBet, state) => {
    const { betItems, settings } = state;
    const maxOdds = get(settings, 'multiple.maxOdds');
    const maxOutcomes = get(settings, 'multiple.maxOutcomes');
    const violations = [];

    if (maxOdds != null && selectedBet.odds != null && selectedBet.outcomes != null) {
      // Starting to accumulating validation errors
      if (maxOdds && selectedBet.odds > maxOdds) {
        violations.push({
          code: BETSLIP_VIOLATION.MAX_ODDS_AMOUNT_EXCEEDED,
          violationInfo: { maxOdds },
        });
      }

      if (maxOutcomes && selectedBet.outcomes.length > maxOutcomes) {
        violations.push({
          code: BETSLIP_VIOLATION.MAX_OUTCOMES_SIZE_EXCEEDED,
          violationInfo: { maxOutcomesSize: maxOutcomes },
        });
      }
    }

    const onlySingleBets = betItems.filter(bet => bet.onlySingle);

    if (!isEmptyCollection(onlySingleBets)) {
      violations.push({
        code: BETSLIP_VIOLATION.SINGLE_BET_ONLY,
        violationInfo: { outcomeIds: onlySingleBets.map(bet => bet.outcomeId) },
      });
    }

    // If no validation errors was found - then its ok
    if (isEmptyCollection(violations)) {
      return false;
    }

    // Returning finded errors
    return {
      code: BETSLIP_ERROR_CODE.BET_VALIDATION_FAILED,
      errors: {
        [selectedBet.requestId]: {
          requestId: selectedBet.requestId,
          violations,
        },
      },
    };
  },
  [BET_TYPE.SYSTEM]: (selectedBet, state) => {
    const { betItems, settings } = state;
    const maxOdds = get(settings, 'system.maxOdds');
    const maxOutcomes = get(settings, 'system.maxOutcomes');
    const violations = [];

    if (maxOdds != null && selectedBet.odds != null && selectedBet.outcomes != null) {
      // Starting to accumulating validation errors
      if (maxOdds && selectedBet.odds > maxOdds) {
        violations.push({
          code: BETSLIP_VIOLATION.MAX_ODDS_AMOUNT_EXCEEDED,
          violationInfo: { maxOdds },
        });
      }

      if (maxOutcomes && selectedBet.outcomes.length > maxOutcomes) {
        violations.push({
          code: BETSLIP_VIOLATION.MAX_OUTCOMES_SIZE_EXCEEDED,
          violationInfo: { maxOutcomesSize: maxOutcomes },
        });
      }
    }

    const onlySingleBets = betItems.filter(bet => bet.onlySingle);

    if (!isEmptyCollection(onlySingleBets)) {
      violations.push({
        code: BETSLIP_VIOLATION.SINGLE_BET_ONLY,
        violationInfo: { outcomeIds: onlySingleBets.map(bet => bet.outcomeId) },
      });
    }

    // If no validation errors was found - then its ok
    if (isEmptyCollection(violations)) {
      return false;
    }

    // Returning finded errors
    return {
      code: BETSLIP_ERROR_CODE.BET_VALIDATION_FAILED,
      errors: {
        [selectedBet.requestId]: {
          requestId: selectedBet.requestId,
          violations,
        },
      },
    };
  },
};

export default function validate(selectedBet, settings) {
  const validationMethod = validationMethodsMap[selectedBet.betType];

  if (typeof validationMethod === 'function') {
    return validationMethod(selectedBet, settings);
  }

  return false;
}
